import { camelCase, filter, head, includes, isEmpty, map, split } from 'lodash';
import React, { useEffect, useState } from 'react';
import Icon from '../../../common/styles/Icon';
import commonResource from '../../../locales/th/common.json';
import { AttributeFacility } from './ProjectAttribute.style';

interface Rooms {
  bedRoom: string;
  other: string;
}
interface RoomType {
  name: string;
}

interface ProjectAttributeProps {
  roomTypes: RoomType[];
}

const ProjectAttribute: React.FC<ProjectAttributeProps> = ({ roomTypes }) => {
  const [rooms, setRooms] = useState<Rooms>({
    bedRoom: '',
    other: '',
  });

  useEffect(() => {
    const getBedRoom = () => {
      const typeBedroom = ['1Bedroom', '2Bedroom', '3Bedroom'];

      const bedRooms = filter(roomTypes, function (roomType) {
        return includes(typeBedroom, camelCase(roomType.name));
      });
      const others = filter(roomTypes, function (roomType) {
        return !includes(typeBedroom, camelCase(roomType.name));
      });

      let bedroom = '';
      let other = '';

      if (bedRooms.length > 0) {
        bedroom =
          map(bedRooms, (room) => head(split(room.name, ' '))).join(',') +
          ' ' +
          commonResource.card.bedRoomApartments;
      }

      if (others.length > 0) {
        other = map(
          others,
          (room) =>
            (commonResource.card as Record<string, string>)[
              camelCase(room.name)
            ],
        ).join(',');
      }

      setRooms({
        bedRoom: bedroom,
        other: other,
      });
    };

    getBedRoom();
  }, [roomTypes]);

  return (
    <AttributeFacility>
      {!isEmpty(rooms.bedRoom) ? (
        <Icon iconName={'bed-small'} leftOfText>
          {rooms.bedRoom + (!isEmpty(rooms.other) ? ',' + rooms.other : '')}
        </Icon>
      ) : (
        rooms.other
      )}
    </AttributeFacility>
  );
};

export { ProjectAttribute };
